import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'discountDisplay',
})
export class DiscountDisplayPipe implements PipeTransform {
  transform(value: number, discountWithSpace = false, isCashDiscount = false): string {
    if (value === 0) {
      return isCashDiscount ? `$${value}` : `${value}%`;
    }

    if (isNaN(value) || typeof value === 'string') {
      return '';
    }

    if (isCashDiscount) {
      return `-$${value}`;
    }

    return discountWithSpace ? `- ${value}%` : `-${value}%`;
  }
}
